<div class="data-wrapper" [class.empty-data-wrapper]="!staffs || (staffs && !staffs.length)"  *ngIf="!isMobile; else elseblock">
  <div class="row">
    <!-- <div class="table-header">拠点</div> -->
    <div class="table-header">氏名</div>
    <div class="table-header">出勤</div>
    <div class="table-header">休憩取得時間</div>
    <div class="table-header">退勤</div>
    <div class="table-header">備考</div>
  </div>
  <div *ngIf="staffs && staffs.length; else noStaffs">
    <div class="row" *ngFor="let staff of staffs; index as i">
      <!-- <div class="data">{{staff.office ? staff.office : '&nbsp;'}}</div> -->
      <div class="data">{{staff.display_name ? staff.display_name : '&nbsp;'}}</div>
      <div class="data">{{staff.time_in ? formatTime(staff.time_in) : '&nbsp;'}}</div>
      <div class="data">{{staff.break_time ? staff.break_time : '&nbsp;'}}</div>
      <div class="data">{{staff.time_out ? formatTime(staff.time_out) : '&nbsp;'}}</div>
      <div class="data">{{staff.remarks ? staff.remarks : '&nbsp;'}}</div>
    </div>
  </div>
  <ng-template #noStaffs>
    <h4 style="background-color: white; font-style: italic; color: gray">No staffs to show</h4>
  </ng-template>
</div>
<ng-template #elseblock>
  <div class="data-wrapper">
    <div class="column">
      <div class="header">拠点</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.office ? staff.office : '&nbsp;'}}</div>
    </div>
    <div class="column">
      <div class="header">氏名</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.name ? staff.name : '&nbsp;'}}</div>
    </div>
    <div class="column">
      <div class="header">出勤</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.time_in ? staff.time_in : '&nbsp;'}}</div>
    </div>
    <div class="column">
      <div class="header">休憩取得時間</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.break_time ? staff.break_time : '&nbsp;'}}</div>
    </div>
    <div class="column">
      <div class="header">退勤</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.time_out ? staff.time_out : '&nbsp;'}}</div>
    </div>
    <div class="column">
      <div class="header">備考</div>
      <div class="data" *ngFor="let staff of staffs">{{staff.remarks ? staff.remarks : '&nbsp;'}}</div>
    </div>
  </div>
</ng-template>